var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetingRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 23,
    viewBox: "0 0 40 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2484 15.1826C33.2484 16.833 31.9711 18.4816 29.5599 19.7559C27.178 21.0147 23.8425 21.8129 20.1226 21.8129C16.4027 21.8129 13.0672 21.0147 10.6852 19.7559C8.27398 18.4816 6.99668 16.833 6.99668 15.1826C6.99668 13.5322 8.27398 11.8837 10.6852 10.6094C13.0672 9.35058 16.4027 8.55234 20.1226 8.55234C23.8425 8.55234 27.178 9.35058 29.5599 10.6094C31.9711 11.8837 33.2484 13.5322 33.2484 15.1826Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1119,
    cy: 15.108,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6064 22.0206C16.7193 19.8935 17.6278 18.2002 18.8742 17.5215M23.6178 22.0206C23.5049 19.8935 22.59 18.2002 21.3404 17.5215",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3531,
    cy: 9.84827,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6104 16.7608C35.3485 16.7608 36.1209 16.7608 38.859 16.7608C38.7461 14.6337 37.8311 12.9405 36.5816 12.2617M34.1154 12.2617C33.6618 12.5087 33.2529 12.8901 32.9109 13.3779",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1119,
    cy: 3.64709,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3398 6.06055C22.2112 6.53389 22.9199 7.50062 23.3073 8.7638M18.8736 6.06055C18.0322 6.51876 17.3447 7.43932 16.9521 8.64359",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.87073,
    cy: 9.8717,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57003 16.7842H1.36523C1.47811 14.6571 2.38656 12.9639 3.63301 12.2852M6.09922 12.2852C6.49251 12.4988 6.85265 12.8129 7.16507 13.2095",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoom);
export default __webpack_public_path__ + "static/media/MeetingRoom.8c42eed659163b843aba88c11d50aa98.svg";
export { ForwardRef as ReactComponent };